<template>
  <div>
    <div class="top-img" v-if="advitiseMent[0]">
      <img :src="advitiseMent[0]" />
    </div>
    <div class="over-time" v-if="dueDate">
      你的超级会员到期日为：{{dueDate}}，点击下方可续费
    </div>
    <div class="top-content">
      <img src="../assets/images/images/superVipContent.png" />
    </div>
    <div class="superVip-content">
      <div class="superVip-item">
        <img class="vip-icon-list" src="../assets/images/images/tipsone.png" />
        <div style="margin-left: 10px; padding: 8px 0">
          <div class="cchc-title">免费发布</div>
          <div style="font-size: 12px; color: gray">
            合规信息不限次数免费发布
          </div>
        </div>
      </div>
      <div class="superVip-item">
        <img class="vip-icon-list" src="../assets/images/images/tipstwo.png" />
        <div style="margin-left: 10px; padding: 8px 0">
          <div class="cchc-title">自动刷新</div>
          <div style="font-size: 12px; color: gray">
            含单条信息自动刷新权限（完整日刷新不少于5次）
          </div>
        </div>
      </div>
      <div class="superVip-item">
        <img
          class="vip-icon-list"
          src="../assets/images/images/tipsthree.png"
        />
        <div style="margin-left: 10px; padding: 8px 0">
          <div class="cchc-title">会员标签</div>
          <div style="font-size: 12px; color: gray">
            拥有V2-V5超级会员标签，提升信息权重
          </div>
        </div>
      </div>
      <div class="superVip-item">
        <img class="vip-icon-list" src="../assets/images/images/tipsfour.png" />
        <div style="margin-left: 10px; padding: 8px 0">
          <div class="cchc-title">顶部推荐</div>
          <div style="font-size: 12px; color: gray">
            含单条信息置顶区第一位置智能推荐展示权限
          </div>
        </div>
      </div>
      <div class="superVip-item">
        <img class="vip-icon-list" src="../assets/images/images/tipsfive.png" />
        <div style="margin-left: 10px; padding: 8px 0">
          <div class="cchc-title">智能匹配</div>
          <div style="font-size: 12px; color: gray">
            含单条信息所有用户个人管理页智能推荐展示权限
          </div>
        </div>
      </div>
    </div>
    <!--开通店铺会员-->
    <div class="openShopVip">
      <div
        v-for="(item, index) in prePayInfo"
        :key="index"
        class="price"
        :style="nowSelect == item.id ? 'border:1px solid #882784;' : ''"
        @click="choosePrice(item.id)"
      >
        <div>{{ item.name }}</div>
        <div>
          <span>￥</span><span>{{ item.fee / 100 }}</span>
        </div>
        <img
          v-if="nowSelect == item.id"
          style="z-index: 99; width: 15px; height: 15px; right: 0; bottom: 0"
          src="../assets/images/images/gouxuan.png"
          alt=""
        />
        <img
          style="transform: rotate(90deg)"
          v-if="nowSelect == item.id"
          src="../assets/images/images/leftTopSelect.png"
          alt=""
        />
      </div>
    </div>
    <!--开通须知-->
    <div class="mustKnow">
      <div v-if="hasRead" @click="changeReadStatus">
        <img src="../assets/images/images/select.png" alt="" />
      </div>
      <div v-else @click="changeReadStatus">
        <img src="../assets/images/images/closeSelect.png" alt="" />
      </div>
      <div>
        我已阅读，并同意<span @click="know" style="color: #892785"
          >《相关条款》</span
        >
      </div>
    </div>
    <div
      @click="showTips = false"
      v-if="showTips"
      style="
        z-index: 9999;
        margin: 0 auto;
        position: fixed;
        bottom: 5%;
        left: 0;
        right: 0;
        width: 30px;
        height: 30px;
      "
    >
      <img src="../assets/images/images/close.png" alt />
    </div>
    <div class="submitInfo">
      <div @click="confirmAddShop">立即支付</div>
      <div @click="giveUpPay">放弃支付</div>
    </div>
    <van-popup class="reset-pop" v-model="showTips">
      <div v-html="tips.content"></div>
    </van-popup>
  </div>
</template>
<script>
let me;
import { Dialog } from "vant";
import { getData, postData } from "../Interface/http.js";
export default {
  data() {
    return {
      prePayInfo: [],
      nowSelect: "", //当前选中的价格
      hasRead: true, //是否
      showTips: false,
      tips: "",
      dueDate: "",//过期时间
      advitiseMent:[],//广告列表
    };
  },
  methods: {
    //查询用户的过期时间
    checkUseDueDate() {
      let that = this;
      postData(
        "/vip/due-date",
        {
          belongs: 2,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token:
              localStorage.getItem("token") != ""
                ? localStorage.getItem("token")
                : "123456",
          },
        }
      )
        .then((res) => {
          if(res.code == 0){
            that.dueDate = res.data.due_date;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    know() {
      getData("/article/agreement?option_id=3").then((res) => {
        this.tips = res.data;
        this.showTips = true;
      });
    },
    //放弃支付
    giveUpPay() {
      this.$router.back(-1);
    },
    //选择价格
    choosePrice(index) {
      this.nowSelect = index;
    },
    getVipList() {
      getData("/vip/refresh-fee?belongs=2").then((res) => {
        console.log(res);
        me.prePayInfo = res.data;
        me.nowSelect = res.data[0].id;
      });
    },
    //切换阅读状态
    changeReadStatus() {
      this.hasRead = !this.hasRead;
    },
    confirmAddShop() {
      if (!me.hasRead) {
        this.$toast("请先阅读相关条款");
        return;
      }
      me.prePayMoney();
    },
    //确认支付
    prePayMoney() {
      postData("/payment/order/create", {
        trade_type: "mp",
        plan_id: me.nowSelect,
      })
        .then((res) => {
          me.onBridgeReady(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //调起微信支付
    onBridgeReady(msg) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", msg, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          //支付完成提交页面信息
          // me.submitInfo();
          Dialog.setDefaultOptions({
            confirmButtonText: "管理信息",
            cancelButtonText: "回到首页",
          });
          Dialog.confirm({
            title: "支付成功",
            message: "点击下方“管理信息”，去设置超级推荐",
          })
            .then(() => {
              me.$router.push({
                name: "myPushMsg",
              });
            })
            .catch(() => {
              me.$router.push({
                name: "home",
              });
            });
          Dialog.resetDefaultOptions();
        }
      });
    },
    getConfigData() {
      //获取配置数据
      let pathname = encodeURIComponent(window.location.pathname);
      let search = encodeURIComponent(window.location.search);
      var u = navigator.userAgent;
      var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      var iPad = u.indexOf("iPad") > -1;
      var iPhone = u.indexOf("iPhone") > -1 || u.indexOf("Mac") > -1;
      let anURL =
        window.location.protocol +
        "//" +
        window.location.host +
        window.location.pathname +
        window.location.search; //安卓地址
      let iosURL = this.$store.state.jumpUrl; //ios地址
      let result = "";
      if (isAndroid) {
        result = anURL;
      }
      if (isiOS || iPad || iPhone) {
        result = iosURL;
      }
      //this.message=result;
      result = encodeURIComponent(result);
      getData("/oauth/credential/jssdk?debug=1&url=" + result).then((res) => {
        wx.config({
          //debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: res.data.appId, // 必填，公众号的唯一标识
          timestamp: res.data.timestamp, // 必填，生成签名的时间戳
          nonceStr: res.data.noncestr, // 必填，生成签名的随机串
          signature: res.data.signature, // 必填，签名，见附录1
          jsApiList: ["chooseImage", "uploadImage"], // 必填，需要使用的JS接口列表，所有JS接口列表见微信公众平台附录
        });
      });
    },
    selectKFImg() {
      //获取广告图片
      let me = this;
      getData("/recommend-lists?position=12")
        .then((res) => {
          if (res.code == 0) {
            var arr = [];
            arr = res.data.map((item) => {
              return item.banner.thumb_url;
            });
            me.advitiseMent.push(...arr);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    me = this;
    me.getVipList();
    me.getConfigData();
    me.selectKFImg();
    me.checkUseDueDate();//查询用户的过期时间
  },
};
</script>
<style>
.over-time {
  margin: 0 5px;
  padding: 10px 5px;
  font-size: 13px;
  color: #882784;
  background-color: #d9cbd8;
  border-radius: 5px;
}
.reset-pop {
  width: 80%;
  max-height: 70% !important;
  border-radius: 3px;
  padding: 10px;
}
.cchc-title {
  display: flex;
  justify-content: flex-start;
  font-size: 16px;
  font-weight: bold;
  color: #882784;
}
.top-img {
  width: 100%;
}
.top-content {
  margin-top: 10px;
}
.superVip-content {
  margin: 0px 25px 0 25px;
}
.vip-icon-list {
  width: 30px;
  height: 30px;
}
.superVip-item {
  display: flex;
  border-bottom: 1px solid #eee;
  align-items: center;
}

.openShopVip {
  display: flex;
  justify-content: space-around;
  padding: 0px 25px;
  flex-wrap: wrap;
  margin-top: 5px;
}
.price {
  width: 99px;
  height: 90px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.price > div:nth-child(1) {
  font-size: 13px;
  font-weight: bold;
  margin-top: 5px;
}
.price > div:nth-child(2) {
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.price > div:nth-child(2) span:nth-child(1) {
  font-size: 20px;
  font-weight: bold;
}
.price > div:nth-child(2) span:nth-child(2) {
  font-size: 30px;
  font-weight: bold;
  color: #892785;
}
.price > div:nth-child(3) {
  font-size: 13px;
  font-weight: bold;
}
.price > div:nth-child(4) {
  color: #892785;
}
.price img {
  width: 30px;
  height: 30px;
  position: absolute;
  right: -1.5px;
  bottom: -1.5px;
}
.mustKnow {
  display: flex;
  font-size: 13px;
  padding: 0 30px;
  justify-content: flex-start;
  align-items: center;
}
.mustKnow > div {
  display: flex;
  align-items: center;
}
.mustKnow img {
  width: 15px;
  height: 15px;
  margin-right: 5px;
}
.submitInfo {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 37px;
}
.submitInfo > div:nth-child(1) {
  width: 331px;
  height: 41px;
  border-radius: 10px;
  background-color: #892785;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 19px;
  color: #fff;
}
.submitInfo > div:nth-child(2) {
  margin-top: 15px;
}
</style>